export const isTypePdf = (string) => {
  const extension = string.substring(string.lastIndexOf(".") + 1);
  if (extension.toLowerCase() === "pdf") {
    return true;
  } else {
    return false;
  }
};

export const isTypeImage = (string) => {
  const extension = string.substring(string.lastIndexOf(".") + 1);
  if (extension.toLowerCase() === "png") {
    return true;
  } else if (extension.toLowerCase() === "jpeg") {
    return true;
  } else {
    return false;
  }
};

export const insertVariables = (string, motion) => {
  let votesFor = 0;
  let votesAgainst = 0;
  for (const vote of motion.votes) {
    if (vote.counts === "positive") {
      votesFor++;
    } else if (vote.counts === "negative") {
      votesAgainst++;
    }
  }
  const tally = `${votesFor} - ${votesAgainst}`;
  const variables = [
    "{{motioner}}",
    "{{motionType}}",
    "{{seconder}}",
    "{{voteResult}}",
    "{{tally}}",
  ];
  // now replace all the strings;
  for (const variable of variables) {
    switch (variable) {
      case "{{motioner}}":
        string = string.replace(variable, motion.motionedBy.name);
        break;
      case "{{motionType}}":
        string = string.replace(variable, motion.motionType?.name);
        break;
      case "{{seconder}}":
        string = string.replace(variable, motion.secondedBy.name);
        break;
      case "{{voteResult}}":
        let resultText = "";
        if (motion.votingResult) {
          resultText = "passing";
        } else {
          resultText = "failed";
        }
        string = string.replace(variable, resultText);
        break;
      case "{{tally}}":
        string = string.replace(variable, tally);
        break;

      default:
        break;
    }
  }
  return string;
};

const calculateVote = (array) => {
  let yea = 0;
  let nay = 0;
  let abstain = 0;
  let recuse = 0;
  try {
    // loop through array and gather vote values
    for (let index = 0; index < array.length; index++) {
      const voteValue = array[index].counts;
      switch (voteValue) {
        case "positive":
          yea++;
          break;
        case "negative":
          nay++;
          break;
        case "abstain":
          abstain++;
          break;
        case "recuse":
          recuse++;
          break;
        default:
          break;
      }
    }

    // voteResult = calcMajority(yea, nay, abstain);
    let totalVotes = yea + nay;
    let compare = totalVotes / 2;
    let resultCompare;
    if (!Number.isInteger(compare)) {
      resultCompare = Math.ceil(compare);
    } else {
      resultCompare = compare + 1;
    }
    let result = yea >= resultCompare ? "passing" : "failed";

    // now return the result
    return result;
  } catch (error) {
    console.error(error);
    // logAction({
    //   function: "session.helpers calculateVote",
    //   array: array,
    //   option: option,
    //   error: JSON.stringify(serializeError(error)),
    // });
  }
};

export const generateMotionWording = (string, motion, topic) => {
  let returnString;
  if (string) {
    returnString = string;
  } else {
    returnString = "";
  }

  let votesFor = 0;
  let votesAgainst = 0;
  let votesAbstain = 0;
  let votesRecuse = 0;
  let votesAbsent = 0;
  let yayVoters = [];
  let nayVoters = [];
  let absentVoters = [];
  let abstainVoters = [];
  let recuseVoters = [];
  for (const vote of motion.votes) {
    switch (vote.counts) {
      case "positive":
        votesFor++;
        yayVoters.push(vote.member);
        break;
      case "negative":
        votesAgainst++;
        nayVoters.push(vote.member);
        break;
      case "abstain":
        votesAbstain++;
        abstainVoters.push(vote.member);
        break;
      case "recuse":
        votesRecuse++;
        recuseVoters.push(vote.member);
        break;
      case "absent":
        votesAbsent++;
        absentVoters.push(vote.member);
        break;
      default:
        break;
    }
  }
  const tally = `${votesFor}-${votesAgainst}-${votesAbstain}-${votesRecuse}-${votesAbsent}`;
  const variables = [
    "{{motioner}}",
    "{{motionType}}",
    "{{seconder}}",
    "{{voteResult}}",
    "{{tally}}",
    "{{fullTally}}",
    "{{description}}",
    "{{subItems}}",
  ];
  if (string) {
    // now replace all the strings;
    for (const variable of variables) {
      switch (variable) {
        case "{{motioner}}":
          returnString = returnString.replace(variable, motion.motionedBy);
          break;
        case "{{motionType}}":
          returnString = returnString.replace(variable, motion.motionType);
          break;
        case "{{seconder}}":
          returnString = returnString.replace(variable, motion.secondedBy);
          break;
        case "{{voteResult}}":
          let resultText = "";
          if (motion.votingResult) {
            resultText = "passing";
          } else {
            resultText = calculateVote(motion.votes);
          }
          returnString = returnString.replace(variable, resultText);
          break;
        case "{{tally}}":
          if (returnString.includes("{{tally}}")) {
            returnString = returnString.replace(variable, tally);
            if (nayVoters.length > 0) {
              returnString =
                returnString + " Opposed by " + nayVoters.join(", ");
            }
            if (abstainVoters.length > 0) {
              returnString =
                returnString + " Abstained by " + abstainVoters.join(", ");
            }
            if (recuseVoters.length > 0) {
              returnString =
                returnString + " Recused by " + recuseVoters.join(", ");
            }
            if (absentVoters.length > 0) {
              returnString =
                returnString + " Absent was " + absentVoters.join(", ");
            }
          }
          break;
        case "{{fullTally}}":
          if (returnString.includes("{{fullTally}}")) {
            returnString = returnString.replace(variable, "");

            const tally = [
              ["Yea", yayVoters],
              ["Nay", nayVoters],
              ["Abstain", abstainVoters],
              ["Recused", recuseVoters],
              ["Absent", absentVoters],
            ];

            for (const [label, voters] of tally) {
              returnString += `\n${label} (${voters.length}): ${voters.length ? voters.join(", ") : "None"}`;
            }
            returnString += "\n";
          }
          break;
        case "{{description}}":
          returnString = returnString.replace(
            variable,
            topic?.topicBlurb ?? "",
          );
          break;
        case "{{subItems}}":
          if (topic?.subTopics?.length > 0) {
            const subItemsText = topic.subTopics
              .map((sub) => `${sub}`)
              .join("\n");
            returnString = returnString.replace(variable, subItemsText);
          } else {
            returnString = returnString.replace(variable, "");
          }
          break;
        default:
          break;
      }
    }
  }
  return returnString;
};

export const checkIfExtended = (string) => {
  const regex = /[a-zA-Z]$/;
  if (regex.test(string)) {
    return incrementLastLetter(string);
  } else {
    return string + "-A";
  }
};

export const incrementLastLetter = (key) => {
  if (key === "Z" || key === "z") {
    return (
      String.fromCharCode(key.charCodeAt() - 25) +
      String.fromCharCode(key.charCodeAt() - 25)
    ); // AA or aa
  } else {
    var lastChar = key.slice(-1);
    var sub = key.slice(0, -1);
    if (lastChar === "Z" || lastChar === "z") {
      // If a string of length > 1 ends in Z/z,
      // increment the string (excluding the last Z/z) recursively,
      // and append A/a (depending on casing) to it
      return (
        incrementLastLetter(sub) +
        String.fromCharCode(lastChar.charCodeAt() - 25)
      );
    } else {
      // (take till last char) append with (increment last char)
      return sub + String.fromCharCode(lastChar.charCodeAt() + 1);
    }
  }
};

// ALSO NEED TO FINISH CONVERTING EVERYWHERE THIS IS USED
export const getAlphabetLetter = (num) => {
  // Decrement num by 1 if bulk is true
  let result = "";

  // Return empty string if num becomes negative after bulk subtraction
  if (num < 0) return "";

  while (num >= 0) {
    const remainder = num % 26;
    result = String.fromCharCode(65 + remainder) + result;
    num = Math.floor(num / 26) - 1;
    // Ensure that the loop eventually exits
    if (num < 0) break;
  }

  return result;
};

// Not Used Anymore
// export const getAlphabetMemoLetterBulk = (num, bulk) => {
//   // Decrement num by 1 if bulk is true
//   // if (bulk) {
//   //   num--;
//   // }
//   num--;

//   let result = "";

//   // Return empty string if num becomes negative after bulk subtraction
//   if (num < 0) return "";

//   while (num >= 0) {
//     const remainder = num % 26;
//     result = String.fromCharCode(65 + remainder) + result;
//     num = Math.floor(num / 26) - 1;
//     // Ensure that the loop eventually exits
//     if (num < 0) break;
//   }

//   return result;
// };

export const hasExternalLinks = (array) => {
  if (array) {
    if (array.length > 0) {
      const fileTypes = new Set(array.map((obj) => obj.fileType));
      return ["google", "office", "konveio", "embed"].some((fileType) =>
        fileTypes.has(fileType),
      );
    } else {
      return false;
    }
  } else {
    return false;
  }
};

export const capitalizeFirstLetter = (inputString) => {
  return inputString.charAt(0).toUpperCase() + inputString.substring(1);
};

export const removeAllUppercase = (text) => {
  return text
    .toLowerCase() // Convert the entire string to lowercase first
    .split(" ") // Split the string into words by spaces
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize first letter of each word
    .join(" "); // Join the words back into a single string
};

export const getPrivateVoteWordig = (vote) => {
  switch (vote) {
    case "positive":
      return "Aye";
    case "negative":
      return "No";
    case "abstain":
      return "Abstain";
    case "recuse":
      return "Recuse";
    case "absent":
      return "Absent";

    default:
      return "";
  }
};

export const tinyMceVariableInsert = (templateString, variables) => {
  return templateString.replace(/\{\{(\w+)\}\}/g, (match, key) => {
    if (key === "attendance" && Array.isArray(variables[key])) {
      return variables[key]
        .map(
          (person) =>
            `<li style="line-height: 1.5; text-align: left;"><span style="color: rgb(0, 0, 0);"><strong>${person.name},</strong> ${person.title}</span></li>`,
        )
        .join("");
    }
    return variables[key] || match;
  });
};

export const isStringifiedJsonObject = (str) => {
  try {
    // Attempt to parse the string as JSON
    var parsed = JSON.parse(str);
    return true;
  } catch (e) {
    // If an error is thrown, it's not a stringified JSON object
    return false;
  }
};

function convertToRoman(num) {
  const romanNumeralMap = [
    { value: 1000, symbol: "M" },
    { value: 900, symbol: "CM" },
    { value: 500, symbol: "D" },
    { value: 400, symbol: "CD" },
    { value: 100, symbol: "C" },
    { value: 90, symbol: "XC" },
    { value: 50, symbol: "L" },
    { value: 40, symbol: "XL" },
    { value: 10, symbol: "X" },
    { value: 9, symbol: "IX" },
    { value: 5, symbol: "V" },
    { value: 4, symbol: "IV" },
    { value: 1, symbol: "I" },
  ];

  let roman = "";

  // Iterate through the romanNumeralMap and construct the roman numeral
  for (let i = 0; i < romanNumeralMap.length; i++) {
    while (num >= romanNumeralMap[i].value) {
      roman += romanNumeralMap[i].symbol;
      num -= romanNumeralMap[i].value;
    }
  }

  return roman;
}

export const getGroupNumber = (type, num, groups, childType) => {
  const currentItem = groups[num];

  // 1. Skip numbering if the item has a parent
  if (currentItem?.parentGroup) {
    // Just in case the function hasn't been updated
    if (!childType) return "";

    const siblings = groups.filter(
      (item, idx) => item.parentGroup === currentItem.parentGroup && idx < num,
    );
    let siblingIndex = siblings.length;
    let childResult = "";
    switch (childType) {
      case "numbers":
      case "numbersHeading":
        return `${siblingIndex + 1}. `;
      case "romanNumerals":
      case "romanNumeralsHeading":
        const roman = convertToRoman(siblingIndex + 1);

        return `${roman}. `;
      case "letters":
      case "lettersHeading":
        // Return empty string if num becomes negative after bulk subtraction
        if (siblingIndex < 0) return "";

        while (siblingIndex >= 0) {
          const remainder = siblingIndex % 26;
          childResult = String.fromCharCode(65 + remainder) + childResult;
          siblingIndex = Math.floor(siblingIndex / 26) - 1;
        }
        return `${childResult}. `;
      // if (siblingIndex < 0) return "";

      // while (siblingIndex >= 0) {
      //   const remainder = siblingIndex % 26;
      //   childResult = String.fromCharCode(65 + remainder) + childResult;
      //   siblingIndex = Math.floor(num / 26) - 1;
      //   // Ensure that the loop eventually exits
      //   if (siblingIndex < 0) break;
      // }
      // return `${childResult}. `;
      case "none":
        return "";
      default:
        return "";
    }
  }

  // 2. Calculate how many parentless items come before this one
  let count = groups.slice(0, num).filter((item) => !item.parentGroup).length;

  let result = "";

  switch (type) {
    case "numbers":
    case "numbersHeading":
      return `${count + 1}. `;
    case "romanNumerals":
    case "romanNumeralsHeading":
      const roman = convertToRoman(count + 1);

      return `${roman}. `;
    case "letters":
    case "lettersHeading":
      // Return empty string if num becomes negative after bulk subtraction
      if (count < 0) return "";

      while (count >= 0) {
        const remainder = count % 26;
        result = String.fromCharCode(65 + remainder) + result;
        count = Math.floor(count / 26) - 1;
      }
      return `${result}. `;
    case "none":
      return "";
    default:
      return "";
  }
};

export const getGroupForTitle = (type, num, groups, childType) => {
  if (!Array.isArray(groups) || num < 0 || num >= groups.length) {
    return ""; // Safe fallback if input is invalid
  }

  const currentItem = groups[num];

  // 1. Skip numbering if the item has a parent
  if (currentItem.parentGroup) {
    // Just in case the function hasn't been updated
    if (!childType) return "";

    const siblings = groups.filter(
      (item, idx) => item.parentGroup === currentItem.parentGroup && idx < num,
    );
    let siblingIndex = siblings.length;
    let childResult = "";
    switch (childType) {
      case "numbers":
        return `${siblingIndex + 1}.`;
      case "romanNumerals":
        const roman = convertToRoman(siblingIndex + 1);
        return `${roman}.`;
      case "letters":
        // Return empty string if num becomes negative after bulk subtraction
        if (siblingIndex < 0) return "";

        while (siblingIndex >= 0) {
          const remainder = siblingIndex % 26;
          childResult = String.fromCharCode(65 + remainder) + childResult;
          siblingIndex = Math.floor(siblingIndex / 26) - 1;
        }
        return `${childResult}`;
      case "none":
        return "";
      default:
        return "";
    }
  }

  // 2. Calculate how many parentless items come before this one
  const count = groups.slice(0, num).filter((item) => !item.parentGroup).length;

  let result = "";

  switch (type) {
    case "numbers":
      return `${count + 1}.`;
    case "romanNumerals":
      const roman = convertToRoman(count + 1);

      return `${roman}.`;
    case "letters":
      // Return empty string if num becomes negative after bulk subtraction
      if (count < 0) return "";

      while (count >= 0) {
        const remainder = count % 26;
        result = String.fromCharCode(65 + remainder) + result;
        count = Math.floor(count / 26) - 1;
      }
      return `${result}`;
    // if (count < 0) return "";

    // while (count >= 0) {
    //   const remainder = count % 26;
    //   result = String.fromCharCode(65 + remainder) + result;
    //   count = Math.floor(num / 26) - 1;
    //   // Ensure that the loop eventually exits
    //   if (count < 0) break;
    // }
    // return `${result}.`;
    case "none":
      return "";
    default:
      return "";
  }

  // let result = "";
  // switch (type) {
  //   case "numbers":
  //     return `${num + 1}`;
  //   case "romanNumerals":
  //     const roman = convertToRoman(num + 1);

  //     return `${roman}`;
  //   case "letters":
  //     // Return empty string if num becomes negative after bulk subtraction
  //     if (num < 0) return "";

  //     while (num >= 0) {
  //       const remainder = num % 26;
  //       result = String.fromCharCode(65 + remainder) + result;
  //       num = Math.floor(num / 26) - 1;
  //       // Ensure that the loop eventually exits
  //       if (num < 0) break;
  //     }
  //     return `${result}`;
  //   case "none":
  //     return "";
  //   default:
  //     return "";
  // }
};

export const getGroupForTitleId = (type, id, agendaGroups, childType) => {
  const currentIndex = agendaGroups?.findIndex(
    (x) => x._id.toString() === id.toString(),
  );
  const currentItem = agendaGroups[currentIndex];

  // 1. Skip numbering if the item has a parent
  if (currentItem?.parentGroup) {
    // Just in case the function hasn't been updated
    if (!childType) return "";

    const siblings = agendaGroups.filter(
      (item, idx) =>
        item.parentGroup === currentItem.parentGroup && idx < currentIndex,
    );
    let siblingIndex = siblings.length;
    let childResult = "";
    switch (childType) {
      case "numbers":
        return `${siblingIndex + 1}`;
      case "romanNumerals":
        const roman = convertToRoman(siblingIndex + 1);
        return `${roman}`;
      case "letters":
        // Return empty string if num becomes negative after bulk subtraction
        if (siblingIndex < 0) return "";

        while (siblingIndex >= 0) {
          const remainder = siblingIndex % 26;
          childResult = String.fromCharCode(65 + remainder) + childResult;
          siblingIndex = Math.floor(siblingIndex / 26) - 1;
        }
        return `${childResult}`;
      case "none":
        return "";
      default:
        return "";
    }
  }

  // 2. Calculate how many parentless items come before this one
  let count = agendaGroups
    .slice(0, currentIndex)
    .filter((item) => !item.parentGroup).length;

  let result = "";

  switch (type) {
    case "numbers":
      return `${count + 1}`;
    case "romanNumerals":
      const roman = convertToRoman(count + 1);

      return `${roman}.`;
    case "letters":
      // Return empty string if num becomes negative after bulk subtraction
      if (count < 0) return "";

      while (count >= 0) {
        const remainder = count % 26;
        result = String.fromCharCode(65 + remainder) + result;
        count = Math.floor(count / 26) - 1;
      }
      return `${result}`;
    case "none":
      return "";
    default:
      return "";
  }

  // switch (type) {
  //   case "numbers":
  //     return `${num + 1}`;
  //   case "romanNumerals":
  //     const roman = convertToRoman(num + 1);

  //     return `${roman}`;
  //   case "letters":
  //     // Return empty string if num becomes negative after bulk subtraction
  //     if (num < 0) return "";

  //     while (num >= 0) {
  //       const remainder = num % 26;
  //       result = String.fromCharCode(65 + remainder) + result;
  //       num = Math.floor(num / 26) - 1;
  //       // Ensure that the loop eventually exits
  //       if (num < 0) break;
  //     }
  //     return `${result}`;
  //   case "none":
  //     return "";
  //   default:
  //     return "";
  // }
};

export const getGroupForTitleEngage = (type, num, groups, childType) => {
  const currentItem = groups[num];

  // 1. Skip numbering if the item has a parent
  if (currentItem?.parentGroup) {
    // Just in case the function hasn't been updated
    if (!childType) return "";

    const siblings = groups.filter(
      (item, idx) => item.parentGroup === currentItem.parentGroup && idx < num,
    );
    let siblingIndex = siblings.length;
    let childResult = "";
    switch (childType) {
      case "numbers":
      case "numbersHeading":
        return `${siblingIndex + 1}. `;
      case "romanNumerals":
      case "romanNumeralsHeading":
        const roman = convertToRoman(siblingIndex + 1);

        return `${roman}. `;
      case "letters":
      case "lettersHeading":
        // Return empty string if num becomes negative after bulk subtraction
        if (siblingIndex < 0) return "";

        while (siblingIndex >= 0) {
          const remainder = siblingIndex % 26;
          childResult = String.fromCharCode(65 + remainder) + childResult;
          siblingIndex = Math.floor(siblingIndex / 26) - 1;
        }
        return `${childResult}. `;
      case "none":
        return "";
      default:
        return "";
    }
  }

  // 2. Calculate how many parentless items come before this one
  const count = groups.slice(0, num).filter((item) => !item.parentGroup).length;

  let result = "";

  switch (type) {
    case "numbers":
    case "numbersHeading":
      return `${count + 1}. `;
    case "romanNumerals":
    case "romanNumeralsHeading":
      const roman = convertToRoman(count + 1);

      return `${roman}. `;
    case "letters":
    case "lettersHeading":
      // Return empty string if num becomes negative after bulk subtraction
      if (count < 0) return "";

      while (count >= 0) {
        const remainder = count % 26;
        result = String.fromCharCode(65 + remainder) + result;
        count = Math.floor(count / 26) - 1;
      }
      return `${result}. `;
    case "none":
      return "";
    default:
      return "";
  }
};

function removeBulkTopics(topics) {
  return topics.filter((topic) => !topic.bulkTopic && !topic.registrationTopic);
}

export const getItemNumber = (
  topics,
  itemNumbering,
  topic,
  position,
  groupNumbering,
  childType,
) => {
  let numberedTitle = topic.title;
  switch (itemNumbering) {
    case "totalNumber":
      const filtered = removeBulkTopics(topics);
      const foundIndex = filtered.findIndex(
        (x) =>
          (x.id && topic.id && x.id.toString() === topic.id.toString()) ||
          (x._id && topic._id && x._id.toString() === topic._id.toString()),
      );
      if (foundIndex >= 0) {
        numberedTitle = `${foundIndex + 1}. ${numberedTitle}`;
      } else {
        numberedTitle = ` ${numberedTitle}`;
      }

      break;
    case "groupNumbers":
      if (topic.agendaGroup.parentGroup) {
        if (childType === "numbers") {
          numberedTitle = `.${position + 1} ${numberedTitle}`;
        } else {
          numberedTitle = `${position + 1}. ${numberedTitle}`;
        }
      } else {
        if (groupNumbering === "numbers") {
          numberedTitle = `${position + 1} ${numberedTitle}`;
        } else {
          numberedTitle = `${position + 1}. ${numberedTitle}`;
        }
      }

      break;
    case "letters":
      let topicLetter = "";
      let num = position; // This is the index or can be calculated differently

      if (num < 0) return ""; // Edge case if number becomes negative

      while (num >= 0) {
        const remainder = num % 26;
        topicLetter = String.fromCharCode(65 + remainder) + topicLetter;
        num = Math.floor(num / 26) - 1;
      }
      numberedTitle = `${topicLetter}. ${numberedTitle}`;

      break;

    case "none":
      numberedTitle = ` ${numberedTitle}`;
      break;

    default:
      break;
  }
  return numberedTitle;
};

export const getItemNumberSortable = (
  topics,
  itemNumbering,
  topic,
  groupNumbering,
  childType,
) => {
  // TODO need to determine position
  const filteredTopics = topics.filter(
    (item) =>
      item.agendaGroup?.id === topic.agendaGroup?.id ||
      item.agendaGroup?._id === topic.agendaGroup?._id,
  );

  const noBulk = filteredTopics.filter((item) => !item.bulkTopic);

  const position = noBulk.findIndex(
    (item) => item.id === topic.id || item._id === topic.id,
  );

  let numberedTitle = topic.title;
  switch (itemNumbering) {
    case "totalNumber":
      const filtered = removeBulkTopics(topics);
      const foundIndex = filtered.findIndex(
        (x) =>
          (x.id && topic.id && x.id.toString() === topic.id.toString()) ||
          (x._id && topic._id && x._id.toString() === topic._id.toString()),
      );
      if (foundIndex >= 0) {
        numberedTitle = `${foundIndex + 1}. ${numberedTitle}`;
      } else {
        numberedTitle = ` ${numberedTitle}`;
      }

      break;
    case "groupNumbers":
      if (topic.agendaGroup.parentGroup) {
        if (childType === "numbers") {
          numberedTitle = `.${position + 1} ${numberedTitle}`;
        } else {
          numberedTitle = `${position + 1}. ${numberedTitle}`;
        }
      } else {
        if (groupNumbering === "numbers") {
          numberedTitle = `${position + 1} ${numberedTitle}`;
        } else {
          numberedTitle = `${position + 1}. ${numberedTitle}`;
        }
      }

      break;
    case "letters":
      let topicLetter = "";
      let num = position; // This is the index or can be calculated differently

      if (num < 0) return ""; // Edge case if number becomes negative

      while (num >= 0) {
        const remainder = num % 26;
        topicLetter = String.fromCharCode(65 + remainder) + topicLetter;
        num = Math.floor(num / 26) - 1;
      }
      numberedTitle = `${topicLetter}. ${numberedTitle}`;

      break;

    case "none":
      numberedTitle = ` ${numberedTitle}`;
      break;

    default:
      break;
  }
  return numberedTitle;
};

export const getItemNumberOnly = (
  topics,
  itemNumbering,
  topic,
  position,
  groupNumbering,
  childType,
) => {
  let numberedTitle = "";
  switch (itemNumbering) {
    case "totalNumber":
      const filtered = removeBulkTopics(topics);
      const foundIndex = filtered.findIndex(
        (x) =>
          (x.id && topic.id && x.id.toString() === topic.id.toString()) ||
          (x._id && topic._id && x._id.toString() === topic._id.toString()),
      );
      if (foundIndex >= 0) {
        numberedTitle = `${foundIndex + 1}. ${numberedTitle}`;
      } else {
        numberedTitle = ` ${numberedTitle}`;
      }

      break;
    case "groupNumbers":
      if (topic.agendaGroup.parentGroup) {
        if (childType === "numbers") {
          numberedTitle = `${position + 1} ${numberedTitle}`;
        } else {
          numberedTitle = `${position + 1}. ${numberedTitle}`;
        }
      } else {
        if (groupNumbering === "numbers") {
          numberedTitle = `${position + 1} ${numberedTitle}`;
        } else {
          numberedTitle = `${position + 1}. ${numberedTitle}`;
        }
      }
      // numberedTitle = `${position + 1}. ${numberedTitle}`;
      break;
    case "letters":
      let topicLetter = "";
      let num = position; // This is the index or can be calculated differently

      if (num < 0) return ""; // Edge case if number becomes negative

      while (num >= 0) {
        const remainder = num % 26;
        topicLetter = String.fromCharCode(65 + remainder) + topicLetter;
        num = Math.floor(num / 26) - 1;
      }
      numberedTitle = `${topicLetter}. ${numberedTitle}`;
      break;

    case "none":
      numberedTitle = ` ${numberedTitle}`;
      break;

    default:
      break;
  }
  return numberedTitle;
};

// export const getAlphabetLetterWithBulk = (num, bulk) => {
//   // Decrement num by 1 if bulk is true
//   if (bulk) {
//     num--;
//   }

//   let result = "";

//   // Return empty string if num becomes negative after bulk subtraction
//   if (num < 0) return "";

//   while (num >= 0) {
//     const remainder = num % 26;
//     result = String.fromCharCode(65 + remainder) + result;
//     num = Math.floor(num / 26) - 1;
//     // Ensure that the loop eventually exits
//     if (num < 0) break;
//   }

//   return result;
// };

// export const getAlphabetMemoLetter = (num) => {
//   // Decrement num by 1 if bulk is true
//   // if (bulk) {
//   //   num--;
//   // }

//   let result = "";

//   // Return empty string if num becomes negative after bulk subtraction
//   if (num < 0) return "";

//   while (num >= 0) {
//     const remainder = num % 26;
//     result = String.fromCharCode(65 + remainder) + result;
//     num = Math.floor(num / 26) - 1;
//     // Ensure that the loop eventually exits
//     if (num < 0) break;
//   }

//   return result;
//   // const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
//   // return letters[num - 1];
// };

export const removeFileExtension = (filename) => {
  return filename.replace(/\.[^/.]+$/, ""); // Removes the last dot and extension
};

export const tarrantInlineText =
  JSON.stringify(`<p style="margin: 0; font-family: 'Times New Roman', serif;"><strong>Closed Meeting upon completion of Open Meeting or at 10:00 a.m., whichever is later: </strong></p>
<p style="margin: 0; font-family: 'Times New Roman', serif;"><strong>(A)&nbsp; to discuss advice about pending or contemplated litigation, a settlement offer, or on a matter in which the duty of the attorney to the County under the Texas Disciplinary Rules of Professional Conduct of the State Bar of Texas conflict with the Texas Open Meeting Act, pursuant to Section 551.071, Texas Government Code; </strong></p>
<p style="margin: 0; font-family: 'Times New Roman', serif;"><strong>(B)&nbsp; to deliberate the purchase, exchange, lease, or value of real property, pursuant to Section 551.072, Texas Government Code; </strong></p>
<p style="margin: 0; font-family: 'Times New Roman', serif;"><strong>(C)&nbsp; to deliberate the appointment, employment, evaluation, reassignment, duties, discipline, or dismissal of a public officer or employee, or to hear complaint or charge against an officer or employee pursuant to Section 551.074, Texas Government Code; </strong></p>
<p style="margin: 0; font-family: 'Times New Roman', serif;"><strong>(D)&nbsp; to deliberate the deployment, or specific occasions for implementation, of security personnel or devices, or a security audit, pursuant to Section 551.076, Texas Government Code; and</strong></p>
<p style="margin: 0; font-family: 'Times New Roman', serif;"><strong>(E)&nbsp; to deliberate a cybersecurity measure, policy or contract solely intended to protect a critical infrastructure facility pursuant to Section 551.0761, Texas Government Code;
<p style="margin: 0; font-family: 'Times New Roman', serif;"><strong>(F)&nbsp; to deliberate the business and financial issues related to a contract being negotiated, pursuant to Section 551.0725, Texas Government Code.</strong></p>
<p style="margin: 0; font-family: 'Times New Roman', serif;"><strong>(G)&nbsp; to deliberate regarding commercial or financial information that the County has received from a business prospect that the County seeks to have locate, stay, or expand near the County and with which the County is conducting economic development negotiations, or to deliberate the offer of a financial or other incentive to a business prospect, pursuant to Section 551.087(1), Texas Government Code.</strong></p>`);

export function makeSafeFilename(filename) {
  if (!filename) return "untitled.pdf";

  // Split into name + extension (only if the last segment looks like one)
  const parts = filename.split(".");
  let ext = "";
  if (parts.length > 1 && /^[a-z0-9]{1,5}$/i.test(parts[parts.length - 1])) {
    ext = parts.pop();
  }

  let name = parts.join("-"); // inner dots become dashes (2026.8.18 -> 2026-8-18)

  // Remove characters Firebase/ConvertAPI may dislike
  name = name
    .replace(/[^a-zA-Z0-9-_ ]/g, "") // only keep letters, numbers, dash, underscore, space
    .replace(/\s+/g, "_") // replace spaces with underscores
    .replace(/_*-_*/g, "-") // "_-_" -> "-"
    .replace(/_+/g, "_") // collapse multiple underscores
    .replace(/-+/g, "-"); // collapse multiple dashes

  // Fallback if name is empty after sanitization
  if (!name) name = "file";

  return ext ? `${name}.${ext}` : name;
}

// File.name is read-only, so re-wrap the file under a safe name when needed
export function withSafeFilename(file) {
  if (!file) return file;
  const safeName = makeSafeFilename(file.name);
  return safeName === file.name
    ? file
    : new File([file], safeName, { type: file.type });
}

export function officeDesktopLink(fileUrl) {
  let url;
  try {
    url = new URL(fileUrl);
  } catch {
    return fileUrl;
  }

  url.searchParams.delete("mobileredirect");

  const filename =
    url.searchParams.get("file") ||
    decodeURIComponent(url.pathname.split("/").pop() || "");

  const dot = filename.lastIndexOf(".");
  const ext = dot === -1 ? "" : filename.slice(dot + 1).toLowerCase();

  const scheme = {
    docx: "ms-word",
    doc: "ms-word",
    docm: "ms-word",
    dotx: "ms-word",
    xlsx: "ms-excel",
    xls: "ms-excel",
    xlsm: "ms-excel",
    csv: "ms-excel",
    pptx: "ms-powerpoint",
    ppt: "ms-powerpoint",
    pptm: "ms-powerpoint",
    vsdx: "ms-visio",
    vsd: "ms-visio",
    mpp: "ms-project",
    accdb: "ms-access",
    mdb: "ms-access",
    pub: "ms-publisher",
  }[ext];

  const cleanUrl = url.toString();
  return scheme ? `${scheme}:ofe|u|${cleanUrl}` : cleanUrl;
}
